import { render, staticRenderFns } from "./BlacklistKeywordAdd.vue?vue&type=template&id=6e2efc5e&"
import script from "./BlacklistKeywordAdd.vue?vue&type=script&lang=js&"
export * from "./BlacklistKeywordAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports